export default "__VITE_ASSET__CMlBsP_r__"